import React from 'react'
import { FAQ_LINKS, faqLinksForTopic, faqReplyLine } from '../../../../shared/faqLinks.js'

/**
 * Insert FAQ link (inbox deflection W6). Answers that match the ticket's topic
 * come first; the rest follow. Picking one adds "question link" to the end of
 * the draft and resets the menu.
 */
export default function FaqLinkPicker({ topic, replyText, setReplyText }) {
  const matched = faqLinksForTopic(topic)
  const others = FAQ_LINKS.filter(link => !matched.includes(link))

  function insert(handle) {
    const link = FAQ_LINKS.find(item => item.handle === handle)
    if (!link) return
    const draft = (replyText || '').replace(/\s+$/, '')
    setReplyText(draft ? `${draft}\n\n${faqReplyLine(link)}` : faqReplyLine(link))
  }

  return (
    <select
      className="form-input"
      value=""
      onChange={e => insert(e.target.value)}
      aria-label="Insert FAQ link"
      title="Add a link to one of our FAQ answers"
      style={{ padding: '4px 6px', fontSize: 11, width: 'auto', minWidth: 120 }}
    >
      <option value="">Insert FAQ link</option>
      {matched.length > 0 && (
        <optgroup label="Matches this ticket">
          {matched.map(link => <option key={link.handle} value={link.handle}>{link.question}</option>)}
        </optgroup>
      )}
      <optgroup label={matched.length > 0 ? 'All other FAQs' : 'All FAQs'}>
        {others.map(link => <option key={link.handle} value={link.handle}>{link.question}</option>)}
      </optgroup>
    </select>
  )
}
